// START Product Tabs JS
var nulTabs;
var nulTab;
var nulTabContent;


window.onload=function() {
  nulTabs=document.getElementById('nul-tabs');

  if(nulTabs) {
    nulTabContent=document.getElementsByClassName('tabContent');
    nulTab=document.getElementsByClassName('tab');
    
    if(!!nulTabContent && !!nulTab && !!nulTabs){
        nulTabs.onclick = function (event) {
            var target=event.target;
            if (target.className=='tab') {
                for (var i=0; i<nulTab.length; i++) {
                    if (target == nulTab[i]) {
                        showTabsContent(i);
                        break;
                    }
                }
            }
        }
        hideTabsContent(1);
    }
  } //END IF
}

function hideTabsContent(a) {
    for (var i=a; i<nulTabContent.length; i++) {
        nulTabContent[i].classList.remove('show');
        nulTabContent[i].classList.add("hide");
        nulTab[i].classList.remove('active');
    }
}

function showTabsContent(b){
    if (nulTabContent[b].classList.contains('hide')) {
        hideTabsContent(0);
        nulTab[b].classList.add('active');
        nulTabContent[b].classList.remove('hide');
        nulTabContent[b].classList.add('show');
    }
}
